import React, { useEffect, useState, useRef } from 'react';
import TimeRangeTabs from './TimeRangeTabs';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CryptoGraph from '../cryptoBalance/CryptoGraph';
import { toFixedTrunc, useJunoCommonFunctions } from '../../../client/Juno/helpers';
import { CircularProgress } from '@mui/material';

const BalancesMobTabSection = ({ currencyFullName, currencyShortName, currencyIcon }) => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const cryptoData = useSelector(state => state.juno.cryptoStats);
    const { getCryptoData } = useJunoCommonFunctions();

    const [graphData, setGraphData] = useState([]);
    const [loading, setLoading] = useState(false);
    const initialFetchRef = useRef(false);

    const currentPrice = cryptoData?.find(
        crypto => crypto?.name?.toLowerCase() === currencyFullName?.toLowerCase(),
    )?.current_price;

    useEffect(() => {
        getCryptoData();
    }, []);

    return (
        <div className="flex flex-col gap-6 bg-[#FFF] dark:bg-[#26272B] p-4 rounded-lg">
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-3">
                    <img
                        src={`${imageBaseUrl}${currencyIcon}`}
                        alt="merchantIcon"
                        className="w-11 h-11"
                    />
                    <p className="!text-text text-base font-semibold leading-6">
                        {currencyFullName}
                        <span className="text-[#51525C] dark:text-[#A0A0AB]  text-base font-semibold leading-6 ml-1">
                            ({currencyShortName})
                        </span>
                    </p>
                </div>

                <div className="flex justify-between items-center">
                    <p className="!text-text font-inter text-[30px] font-semibold leading-[38px]">
                        ${toFixedTrunc(currentPrice, 2) || 0}
                    </p>
                    <div className="hidden md:block lg:hidden">
                        <TimeRangeTabs
                            coinName={currencyFullName}
                            setData={setGraphData}
                            setLoading={setLoading}
                            initialFetchRef={initialFetchRef}
                        />
                    </div>
                </div>
            </div>

            <div className="block md:hidden">
                <TimeRangeTabs
                    coinName={currencyFullName}
                    setData={setGraphData}
                    setLoading={setLoading}
                    initialFetchRef={initialFetchRef}
                />
            </div>

            {loading ? (
                <CircularProgress />
            ) : graphData ? (
                <CryptoGraph
                    height={400}
                    width={'100%'}
                    data={graphData}
                    view="expand"
                    isMobile={true}
                />
            ) : null}
        </div>
    );
};
BalancesMobTabSection.propTypes = {
    currencyFullName: PropTypes.string.isRequired,
    currencyShortName: PropTypes.string.isRequired,
    currencyIcon: PropTypes.string.isRequired,
};
export default BalancesMobTabSection;
